// extracted by mini-css-extract-plugin
module.exports = {"progress":"styles_progress__tKwgH"};